const versionNumber = 0;
const versionDate = '2026.11.03 07:32';
export const environment = {
  apiUrl: 'https://api.platin-beta.inwe.pl',
  wsUrl: 'wss://api.platin-beta.inwe.pl/ws',
  envName: 'beta',
  feVersion: `${versionDate}`,
  beVersion: 'DATE',
  inProgress: false,
  storageHashKey: 'ZZlaiowd7p0a8n3mceaPM:ADANYap;mddASda;pw9m3p0w;fesszs',
  panelInwestoraUrl: 'https://beta1.panel-inwestora-vip.corvus-it.com',
  isBeta: true,
  enableMocks: false,
};
